/**
 * @desc Export entity configuration.
 * @example
 * import { entityConfig } from 'config/entity-info/prior-auth-summary.js';
 */

export const entityConfig = {
    valueColors: {
        status: {
            'Complete - Denial Letter Sent': '#6fb722',
            'Complete - Approved': '#6fb722',
            'Complete - Cancelled': '#e3724a',
            'In Progress - Pending': '#e7aa00',
            'In Progress - Under Review': '#e7aa00',
            'In Progress - Received': '#e7aa00'
        }
    }
};
